import { init_clock } from "./clock";
import {
  frand_rng,
  arr_pick,
  fib_num,
  render_dims,
  fx_shuffle_arr,
  calculateAspectRatioFit,
  bias_arr_pick,
  lerp,
  frand_rng_int,
} from "./local_mods/util.js";

const init_layer = function (layer_idx, scene) {
  const pn_layer_offset_z = lerp(0, 1, layer_idx / scene.num_layers);

  const layer_pos_norm = layer_idx / (scene.num_layers - 1);
  const layer_fig_bias = lerp(scene.OPR ** 2, scene.i_OPR ** 2, layer_pos_norm);
  const layer_is_figure = bias_arr_pick([0, 1], layer_fig_bias);
  const face_img_idx = Math.floor(fxrand() * scene.images.length);

  const prev_ready = false;

  const face_img =
    scene.images[face_img_idx][layer_is_figure ? "figure" : "ground"];

  let min_pop_bias = lerp(scene.i_OPR ** 4, scene.OPR ** 4, layer_pos_norm);
  let layer_pop_min = bias_arr_pick([4, 5, 6, 7], min_pop_bias);
  const layer_pop_rng = { min: layer_pop_min, max: 11 };
  const layer_pop_fact = Math.floor(
    frand_rng_int(layer_pop_rng.min, layer_pop_rng.max)
  );

  const num_clocks = Math.floor(Math.sqrt(fib_num(layer_pop_fact))) ** 2;

  const rows = Math.sqrt(num_clocks);
  const cols = rows;

  // const clk_face_radius_exp = lerp(scene.i_OPR, scene.OPR, layer_pos_norm);
  // const clk_face_radius = Math.pow(
  //   scene.i_OPR,
  //   lerp(
  //     scene.clock_face_radius_fact.min,
  //     scene.clock_face_radius_fact.max,
  //     layer_pop_fact / layer_pop_rng.max,
  //     clk_face_radius_exp
  //   )
  // );
  const clk_face_radius = Math.pow(
    scene.i_OPR,
    lerp(
      scene.clock_face_radius_fact.min,
      scene.clock_face_radius_fact.max,
      layer_pop_fact / (layer_pop_rng.max - 1),
      1
    )
  );

  let layer_mask_arr = get_layer_mask(
    scene.face_mask_img,
    cols,
    rows,
    layer_is_figure
  );
  const clocks = [];
  const layer_anim_fact = arr_pick([6, 7, 8]);
  for (let i = 0; i < num_clocks; i++) {
    if (layer_mask_arr[i]) {
      const clk_props = { pos: { x: 0, y: 0 }, clk_face_radius };
      const ctr_offset_x = 1 / cols / 2;
      const ctr_offset_y = 1 / rows / 2;
      clk_props.pos.x = (i % cols) / cols + ctr_offset_x;
      clk_props.pos.y = Math.floor(i / rows) / rows + ctr_offset_y;
      clk_props.rot_anim_fact = layer_anim_fact;
      clocks.push(init_clock(clk_props, scene));
    }
  }
  return {
    clocks,
    layer_idx,
    layer_is_figure,
    face_img,
    num_clocks,
    pn_layer_offset_z,
    prev_ready,
  };
};

const get_layer_mask = function (mask_img, cols, rows, _layer_is_figure) {
  let mask_arr_vals = [];
  let mask_img_cell_w = mask_img.width / cols;
  let mask_img_cell_h = mask_img.height / rows;
  for (let row = 0; row < rows; row++) {
    let img_section_y = row * mask_img_cell_h;
    for (let col = 0; col < cols; col++) {
      let img_section_x = col * mask_img_cell_w;
      let img_section = mask_img.get(
        img_section_x,
        img_section_y,
        mask_img_cell_w,
        mask_img_cell_h
      );
      img_section.loadPixels();

      let cummulative_val = 0;
      for (let px_idx = 0; px_idx < img_section.pixels.length; px_idx += 4) {
        if (_layer_is_figure) {
          if (img_section.pixels[px_idx] > 0) cummulative_val++;
        } else {
          if (img_section.pixels[px_idx] === 0) cummulative_val++;
        }
      }
      let avg_brightness_val =
        cummulative_val / (img_section.pixels.length / 4);
      let cell_val = 0;
      if (avg_brightness_val > 0.5) cell_val = 1;
      mask_arr_vals.push(cell_val);
    }
  }
  return mask_arr_vals;
};

export { init_layer };
